/**
 * Barrier tool permissions.
 *
 * The barrier tool is GM-only. The server already enforces this on
 * `barrier_create` (rejecting non-GM with permission_denied), so this is a
 * client-side UX gate: non-GM players should not be able to enter barrier
 * mode at all (via the 'B' key, tool activation, or completion) rather than
 * silently bouncing off the server.
 */

export type VTTRole = 'gm' | 'player' | 'observer'

/**
 * Whether a given role may use the barrier tool (enter barrier mode,
 * handle the 'B' shortcut, place/complete barriers). GM only.
 */
export function canUseBarrierTool(role: VTTRole | undefined): boolean {
  return role === 'gm'
}

/**
 * Whether a given role may use the fog tool (paint reveal/hide with the fog
 * brush). GM only — same model as the barrier tool: the toolbar button is
 * already GM-gated and the server enforces it on fog_reveal/fog_hide, so this
 * closes the residual client-side path (direct store poke into 'fog' mode).
 */
export function canUseFogTool(role: VTTRole | undefined): boolean {
  return role === 'gm'
}
